import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { ScreenPickerProps, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { ReadOnlyType } from 'app/area/codetable/item/types';
import { endpoints } from 'app/area/codetable/item/endpoints';
import { useEffect, useState } from 'react';
import { unfilteredOptionsId } from 'app/area/codetable/item/screen-renderer/custom-screens/consequences/constants';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { codePickersId } from 'app/area/indicator-factors/item/code-pickers/types';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const UoM = (props: ScreenPickerProps) => {
  const { breadcrumbs, codeItem, codeItem: { category: { value: consequenceType } = {} } = {},
    updateByKey, resetValidation, options, loadOptions, translation, validation, readOnlyConfig } = props;

  const onChange = (value: CodeComplexValue<number>) => {
    resetValidation(ScreenPicker.uom);
    updateByKey(ScreenPicker.uom, value);
  };

  useEffect(() => {
    resetValidation(ScreenPicker.uom);
    !!consequenceType && loadOptions(unfilteredOptionsId, endpoints.consequenceSeverityFields, { consequenceType });
  }, [consequenceType]);

  const [unfilteredCodes, setUnfilteredCodes] = useState(options?.[unfilteredOptionsId]?.codes);

  useEffect(() => {
    !options?.[unfilteredOptionsId]?.fetching && setUnfilteredCodes(options?.[unfilteredOptionsId]?.codes);
  }, [options?.[unfilteredOptionsId]?.fetching]);

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    const { query } = loadOptionsParams;
    loadOptions(id, endpoints.consequenceSeverityFields, { ...{ query }, consequenceType });
  };

  const codeOptionsWithoutNotSelected = (!!options.uom && options.uom.codes || [])
    .filter(option => option?.value !== 0) as CodeComplexValue<number>[];

  const containsAvailableOptions = unfilteredCodes?.filter(option => option?.value !== 0)?.length > 0;
  const containsNotSelected = unfilteredCodes?.length > unfilteredCodes?.filter(option => option?.value !== 0)?.length;

  const uomValidation = consequenceType && !!validation?.uom ? validation.uom : undefined;
  const finalValidation = { ...uomValidation, ...getDisabledValidation(codeItem?.uom?.disabled, translation.selected_value_disabled) };

  const readOnly = !consequenceType || (readOnlyConfig && readOnlyConfig[ReadOnlyType.all]) || !containsAvailableOptions;

  const uomManageOptionsButton = manageOptionsButton(translation.manage_options,
    codePickersId.substanceUom,
    breadcrumbs);

  return <CodeSinglePicker
    id={ScreenPicker.uom}
    label={translation.unit_of_measure}
    valueItem={codeItem && codeItem.uom}
    searchRequired={false}
    required={!readOnly && containsAvailableOptions && !containsNotSelected}
    readOnly={readOnly}
    options={codeOptionsWithoutNotSelected}
    fetchingOptions={options.uom && options.uom.fetching}
    extraFooterButton={uomManageOptionsButton}
    translation={translation}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
    validation={finalValidation}
  />;
};
